import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {User} from '../../Interfaces/User';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Subscription} from 'rxjs';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {SharedVarService} from '../shared-service.service';
import {GlobalEventsManager} from '../../GlobalEventManager';

@Component({
  selector: 'app-sub-users',
  templateUrl: './sub-users.component.html',
  styleUrls: ['./sub-users.component.css']
})
export class SubUsersComponent implements OnInit {
  myUser = {} as User;
  mySubUser = {} as User;
  myForm: UntypedFormGroup;
  clientRequest: ClientRequest;
  subscription: Subscription;
  userName: string;
  errorOut: string;
  submitted: boolean = false;
  disableSubmit: boolean = false;
  didntEnterShit: boolean = false;
  inquiryMode: boolean = false;
  maherErrorFound: boolean = false;
  showThePasswords: boolean = false;
  saveHit: boolean = false;
  badChars: boolean = false;
  activeConfirm: boolean=true;
  activePass: boolean=true;
  activeAccount: string = "Y";
  public options : {code:string, description:string}[] = [];
  myForm2: UntypedFormGroup;
  numberFound: number;
  totalFound: number;
  lowerFound: number;
  strangeFound: number;
  turnBottomOff: boolean = true;
  noAssignedRoles: boolean = true;
  todo: string [];
  done: string [];

  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, private  globalEventsManager: GlobalEventsManager,public myApp:AppComponent,private service: SharedVarService) {
    this.myForm = fb.group({
      firstName: [{value: '', disabled: !this.submitted}, [Validators.pattern('^[a-zA-Z]+$'), Validators.required]],
      lastName: [{value: '', disabled: !this.submitted}, [Validators.pattern('^[\\.a-zA-Z\\s-]+$'), Validators.required]],
      phone:      [{value: '', disabled: !this.submitted},[Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/),Validators.required]],
      email: [{value: '', disabled: !this.submitted}, [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'), Validators.required]],
    });

    this.myForm2 = fb.group({
      password:   ['', [Validators.required]],
      confirm:  ['', [Validators.required]]},
      {validator: MustMatch('password','confirm')
    });



    this.myUser = this.myApp.user;
/*
        this.myUser = {} as User;
        this.myUser.active ="Y"
        this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
        this.myUser.address_2 = null
        //this.myUser.company_code ="EGN"
        this.myUser.company_code ="L0781"
        this.myUser.company_name= "MAHER TERMINALS, LLC"
        this.myUser.city= "HOUSTON"
        this.myUser.email_address= "cc@dom.com"
        this.myUser.fax_number= "9082373221"
        this.myUser.first_name= "Craig"
        this.myUser.last_name= "Miller"
        this.myUser. maherError= null
        this.myUser.old_password= null
        this.myUser.password= null;
        this.myUser.phone_number= "908338922"
        this.myUser.company_scac= null
        this.myUser.state= "TX"
        this.myUser.userMenuReportItemsView= null
        this.myUser.user_gkey= "8237887"
        // this.myUser.role= "AGENT"
        this.myUser.menuRoleArray = [];
     //     this.myUser.menuRoleArray[0] = "CSP_CONSIGNEE_ROLE";
      //    this.myUser.menuRoleArray[1] = "CSP_ALL_MENUS";
        //this.myUser.role= "LINEOP"
        this.myUser.role= "HAULIER"
        this.myUser.username="CSPTRUCKER"
        this.myUser.zip="07201"
        this.myUser.canSeeAllData = "0";
*/


  }
  ngOnInit() {
    this.options = [];
    this.options.push({"code": "Y", "description": "Yes"});
    this.options.push({"code": "N", "description": "No"});
    this.activeAccount = "Y";




  }

  showConfirmPassword(){
    if (this.activeConfirm){
      this.activeConfirm = false;
    }else{
      this.activeConfirm = true;
    }
  }


  showPassword(){
    if (this.activePass){
      this.activePass = false;
    }else{
      this.activePass = true;
    }
  }

  get f() { return this.myForm.controls;}
  get g() { return this.myForm2.controls;}

  getUsername(){
    this.submitted = true;
    this.badChars = false;
    this.didntEnterShit = false;
    this.inquiryMode = false;
    this.maherErrorFound = false
    if (this.userName==null || this.userName==""){
      this.submitted = false;
      this.didntEnterShit =true;
      return;
    }
  /*  if (!this.service.checkForSpecialChars(this.userName)) {
      this.submitted = false;
      this.badChars = true;
      return;
    }

   */

    this.clientRequest = null;
    this.mySubUser = null;
    this.mySubUser = {} as User;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.mySubUser.username = this.userName;
    this.clientRequest.requestData[0] = this.mySubUser;

    const lhsUserObs$ = this.queryService.getSubUser(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.mySubUser = lhsUser;
      },
      error => {
        this.submitted = false;
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {




          if (this.mySubUser.maherError != null && this.mySubUser.maherError.toUpperCase()!="NOT ON FILE") {
            this.maherErrorFound = true;
            this.errorOut = this.mySubUser.maherError;
            this.submitted = false;
          }else if (this.mySubUser.maherError==null){
            this.showThePasswords = false;
            this.inquiryMode = true;
            this.myForm.controls["firstName"].setValue(this.mySubUser.first_name);
            this.myForm.controls["lastName"].setValue(this.mySubUser.last_name);
            this.myForm.controls["phone"].setValue(this.mySubUser.phone_number);
            this.myForm.controls["email"].setValue(this.mySubUser.email_address);
            this.activeAccount = this.mySubUser.active;
            this.setUpLists();
          }else if (this.mySubUser.maherError.toUpperCase()=="NOT ON FILE") {
            this.myForm.controls["firstName"].enable();
            this.myForm.controls["lastName"].enable();
            this.myForm.controls["phone"].enable();
            this.myForm.controls["email"].enable();
            this.showThePasswords = true;
            this.setUpLists();

          }
      });
  }

  saveSubUser(){
    this.noAssignedRoles = false;
    this.saveHit = true;

    if (this.todo.length==0){
      this.noAssignedRoles = true;
      return;
    }

    if ((this.myForm.valid || this.myForm.disabled) ) {
      if (this.showThePasswords && !this.myForm2.valid){
        return;
      }

      this.clientRequest = null;
      this.clientRequest = {} as ClientRequest;
      this.clientRequest.user = this.myUser;
      this.clientRequest.requestData = [];

      this.mySubUser.username = this.userName;
      this.mySubUser.first_name = this.myForm.controls["firstName"].value;
      this.mySubUser.last_name = this.myForm.controls["lastName"].value;
      this.mySubUser.phone_number = this.myForm.controls["phone"].value;
      this.mySubUser.email_address = this.myForm.controls["email"].value;
      this.mySubUser.active = this.activeAccount;

      if (this.showThePasswords) {
        this.mySubUser.password = this.myForm2.controls["password"].value;
      }

      this.mySubUser.menuRoleArray = [];
      for (var items of this.todo) {
        this.mySubUser.menuRoleArray.push(items);
      }
      this.clientRequest.requestData[0] = this.mySubUser;

      const lhsUserObs$ = this.queryService.saveSubUser(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (lhsUser) => {
          this.mySubUser = lhsUser;
        },
        error => {
          this.submitted = false;
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          this.myApp.showSuccessBanner("", "User has been created/changed successfully", "subUsers");

          this.cancelScreen();
        });
    }
  }



  cancelScreen(){
    this.submitted=false;
    this.saveHit = false;
    this.showThePasswords = false;
    this.myForm.controls["firstName"].disable();
    this.myForm.controls["firstName"].setValue("");
    this.myForm.controls["lastName"].disable();
    this.myForm.controls["lastName"].setValue("");
    this.myForm.controls["phone"].disable();
    this.myForm.controls["phone"].setValue("");
    this.myForm.controls["email"].disable();
    this.myForm.controls["email"].setValue("");
    this.activeAccount = "Y";
    this.myForm2.controls["password"].setValue("");
    this.myForm2.controls["confirm"].setValue("");

    this.todo = null;
    this.done = null;
    this.todo = [];
    this.done = [];
  }

  checkRules(){
    var character='';
    var i=0;

    this.totalFound = 0;
    this.lowerFound = 0;
    this.numberFound = 0;
    this.strangeFound = 0;

    var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    while (i <= this.myForm2.controls["password"].value.length){
      character = this.myForm2.controls["password"].value.charAt(i);
      if (character==""){
      }else if (!isNaN(Number(character))){
        this.numberFound = this.numberFound + 1;
      }else if( character.match(format) ){
        this.strangeFound = this.strangeFound + 1;
      }else if (character == character.toLowerCase()){
        this.lowerFound = this.lowerFound + 1;
      }
      this.totalFound = this.totalFound + 1;
      i++;
    }

  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }


  setUpLists(){
    this.todo = null;
    this.done = null;
    this.todo = [];
    this.done = [];
    for (var items of this.myUser.menuRoleArray) {
      this.done.push(items.valueOf());
    }

    for (var item of this.mySubUser.menuRoleArray) {
        this.todo.push(item.valueOf());
        var indx = this.done.findIndex(xx => xx.valueOf() == item.valueOf());
        if (indx!=-1){
          this.done.splice(indx,1);
        }
    }

  }

}

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}
